document.addEventListener('DOMContentLoaded', () => {
	const tabContainers = document.querySelectorAll('.tab-container');
	const sliderImages = document.querySelectorAll('.slider img:not(.product__media-wrapper .slider img)');
	const mainPreviewImage = document.querySelector('#active-image');
	const mainSliderImages = document.querySelectorAll('.product__media-wrapper .slider img');
	const sliderContainers = document.querySelectorAll('.slider-container');
	let mainImageIndex = 0;
	const mainSliderNextButton = document.querySelector(".main-slider .slider-button--next");
	const mainSliderPrevButton = document.querySelector(".main-slider .slider-button--prev");
	// console.log(mainSliderPrevButton)

	if (tabContainers.length === 0) return; // Validation: Ensure tab containers exist

	tabContainers.forEach(tabContainer => {
		const firstTabButton = tabContainer.querySelector('.tab-button');
		const firstTabPane = tabContainer.querySelector('.tab-pane');

		// Add 'active' class to the first tab button and pane
		if (firstTabButton && firstTabPane) {
			firstTabButton.classList.add('active');
			firstTabPane.classList.add('active');
		}
	});

	document.querySelectorAll('.tab-button').forEach(button => {
		button.addEventListener('click', () => {
			const tabContainer = button.closest('.tab-container');
			if (!tabContainer) return; // Validation: Ensure tabContainer exists
			const targetTab = button.getAttribute('data-tab');
			if (!targetTab) return; // Validation: Ensure targetTab exists

			// Remove active class from all buttons
			tabContainer.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));

			// Hide all tab panes
			tabContainer.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('active'));

			// Activate the selected tab button and pane
			button.classList.add('active');
			const targetPane = tabContainer.querySelector(`#${targetTab}`);
			if (targetPane) targetPane.classList.add('active');
		});
	});

	document.querySelectorAll('.accordion-header').forEach(header => {
		header.addEventListener('click', function () {
			// Close all other accordions
			const allItems = document.querySelectorAll('.accordion-item');
			allItems.forEach(item => {
				if (item !== this.parentElement) {
					item.classList.remove('active');
				}
			});

			// Toggle current accordion
			this.parentElement.classList.toggle('active');
		});
	});


	if (sliderContainers.length !== 0) {
		sliderContainers.forEach((container, index) => {
			const slider = container.querySelector('.slider');
			let images = slider ? slider.children : [];
			if (images.length === 0) return; // Validation: Ensure there are images in the slider

			let currentIndex = 0;
			const prevButton = container.querySelector('.slider-button--prev');
			const nextButton = container.querySelector('.slider-button--next');

			function slide(direction) {
				const totalImages = images.length;
				const sliderBody = container.querySelector('.slider-body');
				if (!sliderBody) return; // Validation: Ensure slider body exists

				const visibleWidth = sliderBody.offsetWidth;
				const imageWidth = images[0].offsetWidth + 25; // Add gap between images
				const visibleImagesCount = Math.floor(visibleWidth / imageWidth);

				// Calculate maxIndex considering partial visibility of the last image
				const maxIndex = Math.max(0, totalImages - visibleImagesCount);

				currentIndex += direction;

				// Clamp currentIndex to valid range
				currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

				// Calculate offset to scroll
				const offset = -currentIndex * imageWidth;
				slider.style.transform = `translateX(${offset}px)`;

				// Update button states
				if (prevButton && index > 0) prevButton.disabled = currentIndex === 0;
				if (nextButton && index > 0) nextButton.disabled = currentIndex === maxIndex;
				
			}
			if (index == 0) {
				function viewNextImage() {
					slide(1);
					// console.log(mainImageIndex, typeof mainImageIndex);

					// console.log(images[mainImageIndex + 1]);
					images = Array.from(images);
					let nextImage = images[mainImageIndex + 1];
					images.forEach((img) => img.classList.remove("active-thumbnail"));
					nextImage.classList.add("active-thumbnail");
					mainPreviewImage.src = nextImage.src;
					mainImageIndex += 1;
					// console.log("Current Index: ", mainImageIndex)
					if (mainSliderPrevButton) mainSliderPrevButton.disabled = mainImageIndex === 0;
					if (mainSliderNextButton) mainSliderNextButton.disabled = mainImageIndex === (images.length - 1);
					
				}
				function viewPrevImage() {
					slide(-1);
					// console.log(mainImageIndex);
					images = Array.from(images);
					let prevImage = images[mainImageIndex - 1];
					images.forEach((img) => img.classList.remove("active-thumbnail"));
					prevImage.classList.add("active-thumbnail");
					mainPreviewImage.src = prevImage.src;
					mainImageIndex -= 1;
					// console.log("Current Index: ", mainImageIndex)
					if (mainSliderPrevButton) mainSliderPrevButton.disabled = mainImageIndex === 0;
					if (mainSliderNextButton) mainSliderNextButton.disabled = mainImageIndex === (images.length - 1);
				}


				// Initialize buttons
				if (mainSliderNextButton && mainSliderPrevButton) {
					mainSliderPrevButton.addEventListener('click', () => viewPrevImage());
					mainSliderNextButton.addEventListener('click', () => viewNextImage());
				}

				if (mainSliderNextButton && images.length <= 1) {
					nextButton.disabled = true;
				}
			}

			if (prevButton && nextButton && index > 0) {
				prevButton.addEventListener('click', () => slide(-1));
				nextButton.addEventListener('click', () => slide(1));
			}

			// Initial state of the buttons
			if (prevButton) prevButton.disabled = true;
			const sliderBody = container.querySelector('.slider-body');
			const visibleWidth = sliderBody ? sliderBody.offsetWidth : 0;
			const imageWidth = images[0].offsetWidth + 25; // Add gap between images
			const visibleImagesCount = Math.floor(visibleWidth / imageWidth);

			if (nextButton && images.length <= visibleImagesCount && index > 0) {
				nextButton.disabled = true;
			}
		});
	}

	mainSliderImages.forEach((img) => {
		img.addEventListener("click", () => { 
			mainPreviewImage.src = img.dataset.src;

            // Remove 'active-thumbnail' class from all thumbnails
            mainSliderImages.forEach((thumb) => thumb.classList.remove('active-thumbnail'));
            // Add 'active-thumbnail' class to the clicked thumbnail
            img.classList.add('active-thumbnail');
            mainImageIndex = parseInt(img.getAttribute("image-index"));
            // console.log("Main Image Index:",mainImageIndex);
            if (mainSliderPrevButton) mainSliderPrevButton.disabled = mainImageIndex == 0;
            if (mainSliderNextButton) mainSliderNextButton.disabled = mainImageIndex == (mainSliderImages.length-1);
		})
	});

	// Attach click event to all images in all sliders
	sliderImages.forEach((image) => {
		image.addEventListener('click', () => {
			// Get the closest slider-container and its unique section ID
			const sliderContainer = image.closest('.slider-container');
			if (!sliderContainer) return; // Validation: Ensure slider container exists
			const sectionId = "{{ section.id }}";

			// Create unique modal HTML
			const modalHtml = `
				<div id="customModal" class="modal" style="display: flex;">
					<span class="close" id="modalClose">&times;</span>
					<div class="modal-content">
						<button class="modal-nav left" id="prevButton">&#10094;</button>
						<div class="modal-image-container">
							<img id="modalImage" class="modal-image" src="${image.src}" alt="${image.alt}">
						</div>
						<button class="modal-nav right" id="nextButton">&#10095;</button>
					</div>
				</div>`;

			// Append the modal to the body
			document.body.insertAdjacentHTML('beforeend', modalHtml);

			const modal = document.getElementById(`customModal`);
			const modalImage = document.getElementById(`modalImage`);
			const modalClose = document.getElementById(`modalClose`);
			const prevButton = document.getElementById(`prevButton`);
			const nextButton = document.getElementById(`nextButton`);

			// Get all images in the slider
			const sliderImages = Array.from(sliderContainer.querySelectorAll('.slider img'));
			let currentIndex = sliderImages.findIndex((sliderImage) => sliderImage === image);

			// Function to update modal image
			const updateModalImage = (index) => {
				if (modalImage && sliderImages[index]) {
					modalImage.src = sliderImages[index].src;
					modalImage.alt = sliderImages[index].alt;
				}
			};

			// Event listener for previous button
			if (prevButton) {
				prevButton.addEventListener('click', () => {
					currentIndex = (currentIndex > 0) ? currentIndex - 1 : sliderImages.length - 1;
					updateModalImage(currentIndex);
				});
			}

			// Event listener for next button
			if (nextButton) {
				nextButton.addEventListener('click', () => {
					currentIndex = (currentIndex < sliderImages.length - 1) ? currentIndex + 1 : 0;
					updateModalImage(currentIndex);
				});
			}

			// Close the modal when the close button is clicked
			if (modalClose) {
				modalClose.addEventListener('click', () => {
					modal.remove();
				});
			}

			// Close the modal when clicking outside the modal content
			if (modal) {
				modal.addEventListener('click', (event) => {
					if (event.target === modal) {
						modal.remove();
					}
				});
			}
		});
	});
	mainPreviewImage.addEventListener('click', () => {
			// Get the closest slider-container and its unique section ID
			const sliderContainer = mainPreviewImage.closest('.slider-container');
			if (!sliderContainer) return; // Validation: Ensure slider container exists
			const sectionId = "{{ section.id }}";

			// Create unique modal HTML
			const modalHtml = `
				<div id="customModal" class="modal" style="display: flex;">
					<span class="close" id="modalClose">&times;</span>
					<div class="modal-content">
						<button class="modal-nav left" id="prevButton">&#10094;</button>
						<div class="modal-image-container">
							<img id="modalImage" class="modal-image" src="${mainPreviewImage.src}" alt="${mainPreviewImage.alt}">
						</div>
						<button class="modal-nav right" id="nextButton">&#10095;</button>
					</div>
				</div>`;

			// Append the modal to the body
			document.body.insertAdjacentHTML('beforeend', modalHtml);

			const modal = document.getElementById(`customModal`);
			const modalImage = document.getElementById(`modalImage`);
			const modalClose = document.getElementById(`modalClose`);
			const prevButton = document.getElementById(`prevButton`);
			const nextButton = document.getElementById(`nextButton`);

			// Get all images in the slider
			const sliderImages = Array.from(sliderContainer.querySelectorAll('.main-slider img'));
			let currentIndex = sliderImages.findIndex((sliderImage) => sliderImage === mainPreviewImage);

			// Function to update modal image
			const updateModalImage = (index) => {
				if (modalImage && sliderImages[index]) {
					modalImage.src = sliderImages[index].src;
					modalImage.alt = sliderImages[index].alt;
				}
			};

			// Event listener for previous button
			if (prevButton) {
				prevButton.addEventListener('click', () => {
					currentIndex = (currentIndex > 0) ? currentIndex - 1 : sliderImages.length - 1;
					updateModalImage(currentIndex);
				});
			}

			// Event listener for next button
			if (nextButton) {
				nextButton.addEventListener('click', () => {
					currentIndex = (currentIndex < sliderImages.length - 1) ? currentIndex + 1 : 0;
					updateModalImage(currentIndex);
				});
			}

			// Close the modal when the close button is clicked
			if (modalClose) {
				modalClose.addEventListener('click', () => {
					modal.remove();
				});
			}

			// Close the modal when clicking outside the modal content
			if (modal) {
				modal.addEventListener('click', (event) => {
					if (event.target === modal) {
						modal.remove();
					}
				});
			}
	});

	async function downloadFile(url) {
		if (!url) return; // Validation: Ensure URL is provided
		try {
			// Fetch the file as a Blob
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error(`Failed to fetch file: ${response.statusText}`);
			}

			const blob = await response.blob();
			const filename = url.substring(url.lastIndexOf('/') + 1);

			// Create a temporary URL for the Blob
			const blobUrl = URL.createObjectURL(blob);

			// Create a temporary anchor element
			const anchor = document.createElement('a');
			anchor.href = blobUrl;
			anchor.download = filename;
			document.body.appendChild(anchor);

			// Trigger the download
			anchor.click();

			// Clean up
			document.body.removeChild(anchor);
			URL.revokeObjectURL(blobUrl);
		} catch (error) {
			console.error('Download failed:', error);
		}
	}
});




